// Chart Color Configuration
// Centralized color definitions for data quality types and signal processing visualization

export const DATA_QUALITY_COLORS = {
  // Low Quality Data Types
  gaps: {
    backgroundColor: '#f97316', // Orange
    borderColor: '#f97316',
    label: 'Gaps'
  },
  nonWear: {
    backgroundColor: '#eab308', // Yellow
    borderColor: '#eab308',
    label: 'Non-Wear'
  },
  jumps: {
    backgroundColor: '#8b5cf6', // Purple
    borderColor: '#8b5cf6',
    label: 'Jumps'
  },
  plummets: {
    backgroundColor: '#ec4899', // Pink
    borderColor: '#ec4899',
    label: 'Plummets'
  },
  extremeNegative: {
    backgroundColor: '#ef4444', // Red
    borderColor: '#ef4444',
    label: 'Extreme Negative'
  },
  proximalLowQuality: {
    backgroundColor: '#6b7280', // Gray
    borderColor: '#6b7280',
    label: 'Proximal Low Quality'
  }
}

// Signal Processing Chart Colors (matching SignalProcessingChart.vue)
export const SIGNAL_PROCESSING_COLORS = {
  // Raw data types
  passed: {
    backgroundColor: 'darkblue',
    borderColor: 'darkblue',
    pointStyle: '.',
    label: 'Passed'
  },
  gap: {
    backgroundColor: 'red',
    borderColor: 'red',
    pointStyle: '.',
    label: 'Gap'
  },
  nonWear: {
    backgroundColor: 'lightpink',
    borderColor: 'lightpink',
    pointStyle: 'cross',
    label: 'Non-Wear'
  },
  jump: {
    backgroundColor: 'lightblue',
    borderColor: 'lightblue',
    pointStyle: 'triangle',
    label: 'Jump'
  },
  plummet: {
    backgroundColor: 'orange',
    borderColor: 'orange',
    pointStyle: 'triangle',
    label: 'Plummet'
  },
  extremeNegative: {
    backgroundColor: 'lightsteelblue',
    borderColor: 'lightsteelblue',
    pointStyle: '*',
    label: 'Extreme Negative'
  },
  proximalLowQuality: {
    backgroundColor: 'gray',
    borderColor: 'gray',
    pointStyle: 'rect',
    label: 'Proximal Low Quality'
  },
  
  // Imputed data types
  gapImputed: {
    backgroundColor: 'gray',
    borderColor: 'black',
    pointStyle: 'circle',
    label: 'Imputed Gap'
  },
  nonWearImputed: {
    backgroundColor: 'lightpink',
    borderColor: 'darkred',
    pointStyle: 'circle',
    label: 'Imputed Non-Wear'
  },
  jumpImputed: {
    backgroundColor: 'lightblue',
    borderColor: 'blue',
    pointStyle: 'circle',
    label: 'Imputed Jump'
  },
  plummetImputed: {
    backgroundColor: 'orange',
    borderColor: 'darkorange',
    pointStyle: 'circle',
    label: 'Imputed Plummet'
  },
  extremeNegativeImputed: {
    backgroundColor: 'lightsteelblue',
    borderColor: 'purple',
    pointStyle: 'circle',
    label: 'Imputed Extreme Negative'
  },
  proximalLowQualityImputed: {
    backgroundColor: 'gray',
    borderColor: 'darkgreen',
    pointStyle: 'circle',
    label: 'Imputed Proximal Low Quality'
  },
  
  // Curve visualization
  curveThreshold: {
    borderColor: 'black',
    borderDash: [5, 5],
    label: 'Curve Threshold'
  },
  curveStart: {
    borderColor: 'rgba(0, 0, 139, 0.9)',
    borderDash: [6, 3],
    label: 'Curve Start'
  },
  curveEnd: {
    borderColor: 'rgba(139, 0, 0, 0.9)',
    borderDash: [6, 3],
    label: 'Curve End'
  }
}

// Helper function to get color for data quality breakdown
export function getDataQualityColor(type) {
  return DATA_QUALITY_COLORS[type] || {
    backgroundColor: '#6b7280',
    borderColor: '#6b7280',
    label: type
  }
}

// Helper function to get signal processing color
export function getSignalProcessingColor(type) {
  return SIGNAL_PROCESSING_COLORS[type] || {
    backgroundColor: '#6b7280',
    borderColor: '#6b7280',
    label: type
  }
}

// Export all colors for easy access
export default {
  DATA_QUALITY_COLORS,
  SIGNAL_PROCESSING_COLORS,
  getDataQualityColor,
  getSignalProcessingColor
}
